export default [
  {
    abbreviation: 'NL',
    name: 'Newfoundland and Labrador',
  },
  {
    abbreviation: 'PE',
    name: 'Prince Edward Island',
  },
  {
    abbreviation: 'NS',
    name: 'Nova Scotia',
  },
  {
    abbreviation: 'NB',
    name: 'New Brunswick',
  },
  {
    abbreviation: 'QC',
    name: 'Quebec',
  },
  {
    abbreviation: 'ON',
    name: 'Ontario',
  },
  {
    abbreviation: 'MB',
    name: 'Manitoba',
  },
  {
    abbreviation: 'SK',
    name: 'Saskatchewan',
  },
  {
    abbreviation: 'AB',
    name: 'Alberta',
  },
  {
    abbreviation: 'BC',
    name: 'British Columbia',
  },
  {
    abbreviation: 'YT',
    name: 'Yukon',
  },
  {
    abbreviation: 'NT',
    name: 'Northwest Territories',
  },
  {
    abbreviation: 'NU',
    name: 'Nunavut',
  },
];
